// Author: Çağrı Erdem, 2023
// Description: Main bundler script for 2groove web app.


// Importing packages
import { Midi } from '@tonejs/midi';
import p5 from 'p5';
import * as Tone from 'tone';
import { WebMidi } from 'webmidi';

// init them
Tone.start();
console.log(`p5.js ${p5.VERSION}`);
const midi = new Midi()
console.log(WebMidi.inputs);


// Importing modules
// ----------------------------
import "./../styles/mainUI.css";
// ----------------------------
import "./efx.js";
import "./globalFetch.js";
import "./interface.js";
import "./pRoll.js";
import "./playback.js";
import "./utils/metronome.js";
import "./workers/facePoseWorker.js";
import "./workers/playbackWorker.js";
import "./workers/tempoWorker.js";
import "./workers/workerAjax.js";
import "./workers/workerQueue.js";
// ----------------------------
import "./facePose.js";
// import "./playbackViz.js"; //now it is imported in play.html
import "./recBatch.js";
import "./utils/utils.js";
// ----------------------------





////////////////////////
// Main script helpers
////////////////////////

function openInNewWindow(url) {
    window.open(url, '_blank', 'width=800,height=700');
}

function handlePlaybackClick(url) {
    // console.log('Opening URL:', url);
    openInNewWindow(url);
}


// Attach event listener when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('playButton').addEventListener('click', function() {
        handlePlaybackClick('./playback.html');
    });
    document.getElementById('infoButton').addEventListener('click', function() {
        handlePlaybackClick('./info.html');
    });
});


// IN5060/src/playback.html
// IN5060/src/js/main.js